import { reactive, ref, computed, watch } from '@vue/composition-api'
import store from '@/store'
import * as apiQA from '@/api/qa'

/**
 * 過去事例を見るウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    /**
     * データロード発動
     * startLoading=trueになった時にloadData()メソッドを実行する
     */
    startLoading: watch(() => {
      if (props.startLoading) {
        group1.loadData()
      }
    }),

    // 表示データリスト
    packages: [],

    // 選択した検索インデックスID
    selectedSearchIndexId: 0,

    // リビジョン名の対応表
    revisionMap: {},
    // 対象リビジョンに対するQAIDの対応表
    qaIdForRivisionMap: {},
    qaIdForLatest: 0, // 最新のQAID

    // データロード完了フラグ
    isListRevisionsLoaded: false,

    /**
     * 表示用データをロードする
     */
    loadData: () => {
 
      // リビジョン一覧API（リビジョン切替用）をコール
      const params = {}
      params.book_id = store.state.qa.bookId
      params.qa_id = store.state.qa.qaId

      apiQA.listRevisionsForChange(params)
        .then(response => {
          if (response) {
            const { data } = response

            group1.packages = data.packages

            // 最新のQAID
            group1.qaIdForLatest = data.qa_id

            // リビジョン名の対応表を生成
            const revisionMapWork = {}
            const qaIdForRivisionMapWork = {}

            const packages = group1.packages ?? []
            for (let i = 0; i < packages.length; i++) {
              const revisions = packages[i].revisions
              for (let k = 0; k < revisions.length; k++) {
                const id = revisions[k].id
                const name = revisions[k].name
                const qaIdForRivision = revisions[k].qa_id
                revisionMapWork['revision_' + id] = name
                qaIdForRivisionMapWork['qa_id_' + id] = qaIdForRivision
              }
            }
            group1.revisionMap = revisionMapWork
            group1.qaIdForRivisionMap = qaIdForRivisionMapWork


            // ラジオボタンの初期選択状態
            let selectedSearchIndexId = 0
            const selectedQaId = store.state.qa.qaId

            if (group1.qaIdForLatest === selectedQaId) {
              selectedSearchIndexId = 0
            } else {
              const packages = group1.packages ?? []
              let isFound = false
              for (let i = 0; i < packages.length; i++) {
                const revisions = packages[i].revisions
                for (let k = 0; k < revisions.length; k++) {
                  const id = revisions[k].id
                  const qaIdForRivision = revisions[k].qa_id
                  if (qaIdForRivision === selectedQaId) {
                    selectedSearchIndexId = id
                    isFound = true
                    break
                  }
                }
                if (isFound) {
                  break
                }
              }
            }

            group1.selectedSearchIndexId = selectedSearchIndexId
           
          }
        })
        .finally(() => {
          group1.isListRevisionsLoaded = true
        })
    },

    /**
     * 設定ボタン押下時
     */
    submit: () => {
      const selectedSearchIndexId = group1.selectedSearchIndexId
      group1.submitWithId(selectedSearchIndexId)
    },

    /**
     * 設定ボタン押下時
     */
    submitWithId: (selectedSearchIndexId) => {

      // 選択した検索インデックスIDを保存
      store.dispatch('qa/setSearchIndexId', selectedSearchIndexId)
      let revisionName = ''
      let qaIdForRivision = 0
      if (selectedSearchIndexId === 0) {
        revisionName = '最新'
        qaIdForRivision = group1.qaIdForLatest // 最新のQAID
      } else {
        revisionName = group1.revisionMap['revision_' + selectedSearchIndexId]
        qaIdForRivision = group1.qaIdForRivisionMap['qa_id_' + selectedSearchIndexId] 
      }
      store.dispatch('qa/setQaId', qaIdForRivision)
      store.dispatch('qa/setRevisionName', revisionName)

      context.emit('changeRevision', qaIdForRivision)

      context.emit('closeSelectRevision')
    }


  })

  return group1
}
